import React from "react";
import RevealAnimation from "../RevealAnimation";
import "./botGCCSection.scss";
import { FiArrowRight, FiPackage, FiSettings, FiGlobe } from "react-icons/fi";
import BuildImg from "../../assets/Images/HowWeDoIt/Completely-Automated-SDLC.svg";
import OperateImg from "../../assets/Images/HowWeDoIt/Synchronised-Development-Operations.svg";
import TransferImg from "../../assets/Images/Hire Remote team/Transition an existing team.svg";
import { navigate } from "gatsby";

const BOTGCCSection = () => {
  const steps = [
    {
      number: "01",
      icon: <FiPackage />,
      title: "Build",
      description: "Powerhouse team delivers your MMP fast.",
      details: [
        "MVP Development",
        "Agile Process",
        "Tech Stack Selection",
        "Architecture Design",
      ],
      highlight: "Speed to Market",
      image: BuildImg,
    },
    {
      number: "02",
      icon: <FiSettings />,
      title: "Operate",
      description: "digiRyte runs a pilot GCC for 6 months covering:",
      details: [
        "Engineering",
        "QA",
        "DevOps",
        "Customer Success",
        "Support",
        "Product Ops",
      ],
      highlight: "At no profit, so founders get stability.",
      image: OperateImg,
    },
    {
      number: "03",
      icon: <FiGlobe />,
      title: "Transfer",
      description:
        "A fully operational capability centre, customised to your culture and growth plan.",
      details: [
        "Legal Entity Setup",
        "HR & Payroll",
        "Assets Transfer",
        "IP Rights Handover",
      ],
      highlight: "Full Ownership Transfer",
      image: TransferImg,
    },
  ];

  return (
    <section className="bot-gcc-section" id="bot-gcc">
      <div className="container">
        <RevealAnimation>
          <div className="section-header">
            <span className="section-badge">The Roadmap</span>
            <h2>Build → Operate → Transfer → GCC</h2>
            <p className="subtitle">From Startup to Scaleup</p>
            <p className="description">
              We don't just build your product; we build your organization.
              Transition seamlessly from a vendor-led model to your own Global
              Capability Centre.
            </p>
          </div>
        </RevealAnimation>

        <div className="process-grid">
          {steps.map((step, index) => (
            <div className="process-card" key={index}>
              <div className="card-image">
                <img src={step.image} alt={step.title} />
                <div className="step-badge">{step.number}</div>
              </div>

              <div className="card-content">
                <div className="card-header">
                  <div className="icon-wrapper">{step.icon}</div>
                  <h3>{step.title}</h3>
                </div>

                <p className="description">{step.description}</p>

                {step.details && (
                  <div className="tags-container">
                    {step.details.map((item, i) => (
                      <span className="tag" key={i}>
                        {item}
                      </span>
                    ))}
                  </div>
                )}
              </div>

              <div className="card-footer">
                <span className="highlight-text">{step.highlight}</span>
              </div>

              {index < steps.length - 1 && (
                <div className="connector-arrow">
                  <FiArrowRight />
                </div>
              )}
            </div>
          ))}
        </div>

        <RevealAnimation delay={0.6}>
          <div className="section-footer">
            <h4>
              This is how your venture becomes self-sustaining and
              investor-ready.
            </h4>
            <button
              className="btn-primary"
              onClick={() => navigate("/contact-us")}
            >
              See How BOT → GCC Works <FiArrowRight />
            </button>
          </div>
        </RevealAnimation>
      </div>
    </section>
  );
};

export default BOTGCCSection;
